import { api } from '@app/config/axios';
import { UserRoles } from '@features/access-control/dto/permissions';

export type GetUserInfoResponse = {
  id: string;
  name: string;
  erpRole: UserRoles | null;
  memberRequest: boolean;
  termsOfUseAccepted: boolean;
  photo?: string | null;
  updatedData: boolean;
};

export async function getUserInfo() {
  const response = await api.get<GetUserInfoResponse>(`/users/information`);

  return response.data;
}
